import { Head, Link } from '@inertiajs/react'
import { Button, Container, Stack, Text, Title } from '@mantine/core'

export default function NotFoundPage() {
  return (
    <>
      <Head title="404 - Not Found" />
      <Container
        size="xl"
        style={{
          padding: 'var(--mantine-spacing-xl)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '50vh',
        }}
      >
        <Stack
          align="center"
          gap="lg"
          style={{ maxWidth: '640px', textAlign: 'center' }}
        >
          <Title order={1} size="4rem" fw={800} style={{ lineHeight: 1 }}>
            404
          </Title>
          <Title order={2} size="2rem" fw={700}>
            You have found a secret place.
          </Title>
          <Text size="lg" c="dimmed">
            Unfortunately, this is only a 404 page. You may have mistyped the
            address, or the page has been moved to another URL.
          </Text>
          <Button component={Link} href="/" size="md" mt="md">
            Back to home page
          </Button>
        </Stack>
      </Container>
    </>
  )
}
